import useIsDarkMode from './useIsDarkMode';

export default useIsDarkMode;
